(function() {
    if (typeof CSS !== 'undefined' && CSS.supports('selector(:has(*))')) {
        return;
    }

    console.log('[Firefox补丁] 启用子菜单控制 (重排增强版)');

    const MENU_ITEM_SELECTOR = '.menu-list__list-item';
    const SUBMENU_SELECTOR = '.menu-list__submenu-inner';
    const HIDE_DELAY = 150;

    let activeLi = null;
    let hideTimer = null;

    // 强制触发重排并确保内部卡片可见
    function forceLayout(sub) {
        // 强制重排
        void sub.offsetHeight;

        // 查找内部所有产品卡片，强制显示并设置最小高度
        const cards = sub.querySelectorAll('.product-card, .product-grid__item');
        cards.forEach(function(card) {
            card.style.display = 'block';
            card.style.opacity = '1';
            card.style.minHeight = '200px'; // 与 CSS 一致
            // 处理图片容器
            const media = card.querySelector('.product-media-container');
            if (media) {
                media.style.display = 'block';
                media.style.minHeight = '180px';
                media.style.height = 'auto';
                const img = media.querySelector('img');
                if (img) {
                img.style.height = '100%';
                img.style.objectFit = 'contain';
                img.style.minHeight = '150px';
                }
            }
        });
    }

    function showSubmenu(li){
        const sub = li.querySelector(SUBMENU_SELECTOR);
        if(sub){
            sub.style.visibility='visible';
            sub.style.opacity='1';
            sub.style.removeProperty('height');
            sub.style.removeProperty('overflow');
            sub.style.removeProperty('pointer-events');
            void sub.offsetHeight;
        }
        activeLi=li;
    }

    function hideSubmenu(li){
        const sub=li.querySelector(SUBMENU_SELECTOR);
        if(sub){
            sub.style.visibility='hidden';
            sub.style.opacity='0';
            sub.style.removeProperty('height');
            sub.style.removeProperty('overflow');
            sub.style.removeProperty('pointer-events');
        }
        if(activeLi===li){
            activeLi=null;
        }
    }

    // ---- 事件监听（与之前相同，但调用新函数） ----
    document.addEventListener('pointerenter', function(e) {
        const li = e.target.closest(MENU_ITEM_SELECTOR);
        if (!li) return;
        if (li === activeLi) return;
        if (hideTimer) {
            clearTimeout(hideTimer);
            hideTimer = null;
        }
        if (activeLi) {
            hideSubmenu(activeLi);
        }
        showSubmenu(li);
    }, true);

    document.addEventListener('pointerleave', function(e) {
        const li = e.target.closest(MENU_ITEM_SELECTOR);
        if (!li) return;
        const related = e.relatedTarget;
        if (related && li.contains(related)) return;
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function() {
        if (activeLi === li) {
            hideSubmenu(li);
        }
        hideTimer = null;
        }, HIDE_DELAY);
    }, true);

    document.addEventListener('pointerenter', function(e) {
        const sub = e.target.closest(SUBMENU_SELECTOR);
        if (sub) {
        const li = sub.closest(MENU_ITEM_SELECTOR);
        if (li) {
            if (hideTimer) {
                clearTimeout(hideTimer);
                hideTimer = null;
            }
            if (activeLi !== li) {
            if (activeLi) hideSubmenu(activeLi);
                showSubmenu(li);
            } else {
                // 已经在激活状态，但确保内部强制布局（可能子菜单内容动态变化）
                forceLayout(sub);
            }
        }
        }
    }, true);

    document.addEventListener('pointerleave', function(e) {
        const sub = e.target.closest(SUBMENU_SELECTOR);
        if (sub) {
        const li = sub.closest(MENU_ITEM_SELECTOR);
        if (li) {
            const related = e.relatedTarget;
            if (related && li.contains(related)) return;
            if (hideTimer) clearTimeout(hideTimer);
            hideTimer = setTimeout(function() {
            if (activeLi === li) {
                if (li.matches(':hover')) return;
                hideSubmenu(li);
            }
            hideTimer = null;
            }, HIDE_DELAY);
        }
        }
    }, true);

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll(SUBMENU_SELECTOR)
        .forEach(function(sub) {
            sub.style.visibility='hidden';
            sub.style.opacity='0';
        });
    });

    console.log('[Firefox补丁] 已激活 (重排增强版)');

    // ===== 新增：隐藏单图箭头 =====
    function hideArrowsWhenSingleSlide() {
        document.querySelectorAll('slideshow-component').forEach(function(comp) {
            // 检查该组件内 slideshow-slide 的数量
            var slides = comp.querySelectorAll('slideshow-slide');
            if (slides.length <= 1) {
                var arrows = comp.querySelector('slideshow-arrows');
                if (arrows) {
                    arrows.style.display = 'none';
                }
            }
        });
    }

    // 在 DOM 加载完成后执行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hideArrowsWhenSingleSlide);
    } else {
        hideArrowsWhenSingleSlide();
    }
})();
